export const PROGRAMS_LIST_REQUEST = "PROGRAMS_LIST_REQUEST";
export const PROGRAMS_LIST_SUCESS = "PROGRAMS_LIST_SUCESS";
export const PROGRAMS_LIST_FAIL = "PROGRAMS_LIST_FAIL";